<template>
    <div>
        <app-header></app-header>
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top pad-bottom--large">
                <div class="cell small-12 medium-10 medium-offset-1">
                    <h1 class="pad-top">Why Choose Us</h1>
                    <h4 class="text-blue">Customer Satisfaction:</h4>
                    <p>
                        Perfect &amp; On Time, Every Time – Okay, no one is perfect but we do aim
                        to deliver every single order on-time, in perfect condition, every time.
                        If we are unable to do so we aim to swiftly resolve any issue by either
                        replacing the order, offering a refund or account credit. For bulk orders
                        we do always recommend buying a sample first to ensure that you are
                        completely happy with the end product.
                    </p>
                    <h4 class="text-blue">Quality &amp; Commitment to Excellence:</h4>
                    <p>
                        Quality is embedded within our company ethos from order processing and
                        graphic design to customisation and finally dispatch we monitor the
                        quality trail of every order to ensure customer satisfaction with a
                        view to always improving on a continuous basis.
                    </p>
                    <h4 class="text-blue">In-House Design &amp; Production:</h4>
                    <p>
                        We have our own in-house Design &amp; Production facility which means that
                        we have complete control on the quality, design & customisation of every
                        order.
                    </p>
                    <h4 class="text-blue">
                        Ethical, Environmentally focused &amp; Responsible Supply Chain:
                    </h4>
                    <p>
                        We are proud to have a focused approach to ensuring that our supply
                        chain is transparent, environmentally friendly and remains ethical at
                        all stages from the suppliers that we buy from to the inks that we print
                        with.
                    </p>
                    <h4 class="text-blue">Technologically Driven:</h4>
                    <p>
                        Technology is at the very heart of our business and it is used in
                        innovative ways to improve efficiencies, maintain a high level of
                        quality and reduce errors which enables us to deliver the highest
                        quality of customised clothing promptly.
                    </p>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Why Choose Us',
    metaInfo() {
        return {
            title: 'Why Choose Us',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Why choose Customised Clothing' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/why-choose-us' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/WhyChooseUs.vue